<template>
  <div>
    <v-app-bar color="farmer_green" dark app>
      <v-app-bar-nav-icon @click="sideNav = !sideNav" class="hidden-sm-and-up mr-1"></v-app-bar-nav-icon>
      <v-layout align-center>
        <a @click="goToPath('/')">
          <img alt="Farmet Platform Logo" contain :src="require('../assets/zf-logo-white-cirle.png')" transition="scale-transition" width="auto" height="50" class="ml-2 mt-2" />
        </a>

        <!-- <v-spacer></v-spacer>

        <h1 id="toolbar-title" @click="goToPath('/')">
          Zambezi Farmer
        </h1> -->

        <v-spacer></v-spacer>

        <v-btn v-for="(item, index) in menuItems" :key="index" :to="item.link" class="hidden-xs-only" large tile text>{{item.title}}</v-btn>
        <v-btn text @click="goToPath('/favorites')">
          <v-badge v-if="favoriteProductsIds.length > 0" :content="favoriteProductsIds.length" top right color="red" class="mr-5  mt-2">
            <v-icon>favorite_border</v-icon>
          </v-badge>
          <v-badge v-else top right class="mt-1">
            <v-icon>favorite_border</v-icon>
          </v-badge>
        </v-btn>
        <template v-if="!user">
          <v-btn small class="mr-3 farmer_teal white--text" to="sign-in">Login</v-btn>
          <v-btn small elevation="3" outlined class="famer_teal" to="sign-up">Sign Up</v-btn>
        </template>
        <v-menu v-else offset-y offset-x origin="top right" :nudge-bottom="6" :nudge-width="200" transition="scale-transition">
            <template v-slot:activator="{ on }">
              <!-- slot="activator"> -->
              <v-btn icon large v-on="on">
                <v-avatar size="30px">
                  <v-icon>person</v-icon>
                </v-avatar>
              </v-btn>
            </template>
            <v-list class="pa-0">
              <v-list-item-group color="primary">
                <v-list-item v-for="(item, index) in profileItems" :to="!item.href ? { name: item.name } : null" :href="item.href" @click="item.click" :disabled="item.disabled" :target="item.target" rel="noopener" :key="index">
                  <v-list-item-action>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
      </v-layout>
    </v-app-bar>

    <v-navigation-drawer v-model="sideNav" fixed clipped temporary :width="220" app>
      <v-app-bar color="farmer_green" dark>
        <v-layout align-center>
          <v-app-bar-nav-icon @click="sideNav = !sideNav" class="hidden-sm-and-up"></v-app-bar-nav-icon>

          <v-spacer></v-spacer>
          <a @click="goToPath('/')">
            <img alt="Farmet Platform Logo" contain :src="require('../assets/zf-logo-white-cirle.png')" transition="scale-transition" width="auto" height="50" class="mt-" />
          </a>
          <v-spacer></v-spacer>

        </v-layout>
      </v-app-bar>

      <v-list>
        <v-list-item v-for="(item, index) in menuItems" :key="index" :to="item.link" color="farmer_green">
          <v-list-item-action>
            <v-icon>{{item.icon}}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            {{item.title}}
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      sideNav: false
    }
  },
  computed: {
    ...mapGetters(['user', 'favoriteProductsIds']),
    menuItems() {
      // use 'let' to assign different menu for authenticated users
      const menuItems = [
        { icon: 'contact_phone', title: 'Contact us', link: '/contact' },
        { icon: 'info', title: 'About us', link: '/about' }
      ]
      return menuItems
    },
    profileItems() {
      let profileItems = []

      /**
       * if user is signed in
       */
      // TODO: add profile and settings pages
      // { icon: 'account_circle', title: 'Profile', click: () => goToPath('/profile') },
      // { icon: 'settings', title: 'Settings', click: () => goToPath('/settings') },
      if (this.user) {
        switch (this.user.type) {
          case 'customer':
            profileItems = [
              { icon: 'exit_to_app', title: 'Logout', click: () => { this.onLogout() } }
            ]
            break
          case 'independent':
          case 'business':
          case 'admin':
            profileItems = [
              { icon: 'dashboard', title: 'Dashboard', click: () => { this.goToAdminPanel() } },
              { icon: 'exit_to_app', title: 'Logout', click: () => { this.onLogout() } }
            ]
            break
        }
      }
      return profileItems
    }
  },
  methods: {
    onLogout() {
      this.$store.dispatch('logout')
      this.goToPath('/')
    },
    goToAdminPanel() {
      if (this.user.isAdmin) {
        this.goToPath('/suppliers')
      } else {
        this.goToPath('/my-products')
      }
    }
  }
}
</script>

<style scoped>
#toolbar-title {
  color: linear-gradient(#e66465, #9198e5);
}
</style>
